import { render, staticRenderFns } from "./LeaveUpdated.vue?vue&type=template&id=15995bc1"
import script from "./LeaveUpdated.vue?vue&type=script&lang=js"
export * from "./LeaveUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports